import {
  Button as RACButton,
  ButtonProps as RACButtonProps,
  Header as RACHeader,
  Menu as RACMenu,
  MenuItem as RACMenuItem,
  MenuItemProps as RACMenuItemProps,
  MenuProps as RACMenuProps,
  MenuSection as RACMenuSection,
  MenuSectionProps as RACMenuSectionProps,
  MenuTrigger as RACMenuTrigger,
  Separator as RACSeparator,
  SeparatorProps as RACSeparatorProps,
} from 'react-aria-components';

import { ButtonProps } from '../Button';

export function Menu<T extends object>(props: RACMenuProps<T>) {
  return <RACMenu className="hlx-menu" {...props} />;
}

export function MenuItem<T extends object>(props: RACMenuItemProps<T>) {
  return <RACMenuItem className="hlx-menu-item" {...props} />;
}

interface MenuSectionProps<T extends object> extends RACMenuSectionProps<T> {
  title?: string;
}

export function MenuSection<T extends object>(props: MenuSectionProps<T>) {
  return <RACMenuSection className="hlx-collection-section" {...props} />;
}

export function Separator(props: RACSeparatorProps) {
  return <RACSeparator className="hlx-collection-separator" {...props} />;
}

type HeaderProps = React.ComponentProps<typeof RACHeader>;

export function MenuSectionHeader(props: HeaderProps) {
  return <RACHeader className="hlx-collection-section-heading" {...props} />;
}

export function MenuTriggerButton(props: ButtonProps & RACButtonProps) {
  return (
    <RACButton
      className="hlx-button"
      data-hlx-variant={props.variant}
      data-hlx-size={props.size}
      data-hlx-disabled={props.disabled}
      {...props}
    />
  );
}

export function CircularMenuButton({
  children,
  'aria-label': ariaLabel,
}: RACButtonProps & {
  children: React.ReactNode;
  ['aria-label']: string;
}) {
  return (
    <RACButton className="hlx-circular-menu-button" aria-label={ariaLabel}>
      {children}
    </RACButton>
  );
}

export { RACMenuTrigger as MenuTrigger };
